import Vue from 'vue';
import VueRouter from 'vue-router';
import home from '../pages/home';
import recharge from '../pages/recharge';
import ticketCode from '../pages/ticketCode';
import loading from '../pages/loading';
import phoneCost from '../pages/phoneCost';
import oilCost from '../pages/oilCost';
import oilStationList from '../pages/oilStationList';
import cake from '../pages/cake';
import cakeCode from '../pages/cakeCode';
import kami from '../pages/kami';
import qrCode from '../pages/qrCode';
import starbuck from '../pages/starbuck';
import music from '../pages/music';
import musicCode from '../pages/musicCode';
import kamiCode from '../pages/kamiCode';
import index from '../pages/index';
import notFind from '../pages/404';
import xianfengsg from '../pages/xianfengsg';
import xianfengsgCode from '../pages/xianfengsgCode';
import sjlhStore from '../pages/sjlhStore';
import xianfengsgStore from '../pages/xianfengsgStore';
import drjingStore from '../pages/drjingStore';
import drjingCode from '../pages/drjingCode.vue';
import commonIndex from '../pages/commonIndex.vue';
import manyType from '../pages/manyType.vue';
import manyTypeCode from '../pages/manyTypeCode.vue';
import wangyi from '../pages/wangyi.vue';
import moshoushijie from '../pages/moshoushijie.vue';
import newOilCost from '../pages/newOilCost.vue';
import newTicketCode from '../pages/newTicketCode.vue';
Vue.use(VueRouter)

const routes = [{
		path: '/',
		component: loading
	},
	{
		path: '/home',
		component: home,
		meta: {
			title: "云之谷四网视频充值"
		}
	},
	{
		path: '/recharge',
		component: recharge
	},
	{
		path: '/ticketCode',
		component: ticketCode
	},
	{
		path: '/phoneCost',
		component: phoneCost
	},
	{
		path: '/oilCost',
		component: oilCost
	},
	{
		path: '/oilStationList',
		component: oilStationList,
		meta: {
			title: "中国石油加油站网点列表"
		}
	},
	{
		path: '/cakeCode',
		component: cakeCode,
		meta: {
			title: "云之谷LadyM蛋糕券"
		}
	},
	{
		path: '/cake',
		component: cake,
		meta: {
			title: '云之谷LadyM蛋糕券'
		}
	},
	{
		path: '/kami',
		component: kami,
		meta: {
			title: '卡密电子券'
		}
	},
	{
		path: '/starbuck',
		component: starbuck,
		meta: {
			title: '星巴克电子券'
		}
	},
	{
		path: '/music',
		component: music,
		meta: {
			title: '网易云音乐'
		}
	},
	{
		path: '/index',
		component: index
	},
	{
		path: '/qrCode',
		component: qrCode
	},
	{
		path: '/musicCode',
		component: musicCode
	},
	{
		path: '/kamiCode',
		component: kamiCode
	},
	{
		path: '/404',
		component: notFind,
		meta: {
			title: '电子券不存在'
		}
	},
	{
		path: '/xianfengsg',
		component: xianfengsg,
	},
	{
		path: '/xianfengsgCode',
		component: xianfengsgCode,
	},
	{
		path: '/sjlhStore',
		component: sjlhStore,
	},
	{
		path: '/xianfengsgStore',
		component: xianfengsgStore,
	},
	{
		path: '/drjingStore',
		component: drjingStore,
	},
	{
		path: '/drjingCode',
		component: drjingCode,
	},
	{
		path: '/commonIndex',
		component: commonIndex,
	},
	{
		path: '/manyType',
		component: manyType,
	},
	{
		path: '/manyTypeCode',
		component: manyTypeCode,
	},
	{
		path: '/wangyi',
		component: wangyi,
	},
	{
		path: '/moshoushijie',
		component: moshoushijie,
	},
	{
		path: '/newOilCost',
		component: newOilCost,
	},
	{
		path: '/newTicketCode',
		component: newTicketCode,
	},
]

var router = new VueRouter({
	routes
})

export default router
